export default __webpack_public_path__ + "static/media/default-doc.963f3274.png";